// src/features/settings/config/useConfig.ts
import { useSyncExternalStore, useMemo } from 'react';
import { configStore } from './configStore';
import type { AppConfig } from './config';

export function useConfig(): {
  config: AppConfig;
  setData: (p: Partial<AppConfig> | ((prev: AppConfig) => Partial<AppConfig>)) => void;
  setSeriesID: (id: string) => Promise<void>;
  getColors: (key: string) => string | string[] | undefined;
} {
  const config = useSyncExternalStore(
    (listener) => configStore.subscribe(listener),
    () => configStore.get(),
    () => configStore.get(), // SSR
  );

  return useMemo(
    () => ({
      config,
      setData: (p) => configStore.setData(p),
      setSeriesID: (id: string) => configStore.setSeriesID(id),
      getColors: (key: string) => configStore.getColors(key),
    }),
    [config],
  );
}
